import { render, staticRenderFns } from "./CadastreBuildingFieldReferenceEditModal.vue?vue&type=template&id=2d194fab&scoped=true&"
import script from "./CadastreBuildingFieldReferenceEditModal.vue?vue&type=script&lang=js&"
export * from "./CadastreBuildingFieldReferenceEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d194fab",
  null
  
)

export default component.exports